module.exports = __webpack_public_path__ + "static/media/download-google-play.437e38d4.png";